// extracted by mini-css-extract-plugin
export default {"heading":"BackgroundCover_heading__0vwmu","inner":"BackgroundCover_inner__aflO4"};